import { render, staticRenderFns } from "./SurveyBidModelView.vue?vue&type=template&id=63468766&scoped=true&"
import script from "./SurveyBidModelView.vue?vue&type=script&lang=js&"
export * from "./SurveyBidModelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63468766",
  null
  
)

export default component.exports